export default {
  // 设置cookie
  setCookie(cName, value, expire) {
    // debugger;
    const date = new Date();
    date.setSeconds(date.getSeconds() + expire);
    document.cookie = `${cName}=${escape(value)};expires=${date.toGMTString()};path=/`;
  },

  // 获取cookie
  getCookie(cName) {
    if (document.cookie.length > 0) {
      let cStart = document.cookie.indexOf(`${cName}=`);
      if (cStart !== -1) {
        cStart = cStart + cName.length + 1;
        let cEnd = document.cookie.indexOf(';', cStart);
        if (cEnd === -1) cEnd = document.cookie.length;
        return unescape(document.cookie.substring(cStart, cEnd));
      }
    }
    return '';
  },

  // 删除cookie
  deleteCookie(cName) {
    this.setCookie(cName, '', -1000);
  },

  // 格式化日期
  // 统一格式化：YYYY-MM-DD HH:mm:ss
  formatDate(date, type = 'date', separator = '/') {
    if (!date) return date;
    if (typeof date === 'string') {
      if (!date.trim()) {
        return date;
      }
      // IE 下不支持 YYYY-MM-DD 连接符的格式，需转成 /
      date = new Date(date.replace(/-/g, '/').replace('T', ' '));
    } else {
      date = new Date(date); // 格式化时间戳（注意根据后台数据看需不需要乘以1000）
    }

    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    month = month < 10 ? `0${month}` : month;
    day = day < 10 ? `0${day}` : day;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = minute < 10 ? `0${minute}` : minute;
    second = second < 10 ? `0${second}` : second;
    if (type === 'date') {
      return `${year}${separator}${month}${separator}${day}`;
    }
    if (type === 'datetime') {
      return `${year}${separator}${month}${separator}${day} ${hour}:${minute}:${second}`;
    }
    if (type === 'time') {
      return `${hour}:${minute}:${second}`;
    }
    return date;
  },
  formatDate2(date, type = "datetime", separator = "/") {
    if (!date) return date;
    if (typeof date === "string") {
      if (!date.trim()) {
        return date;
      }
      // IE 下不支持 YYYY-MM-DD 连接符的格式，需转成 /
      date = new Date(date.replace(/-/g, "/").replace("T", " "));
    } else {
      date = new Date(date); // 格式化时间戳（注意根据后台数据看需不需要乘以1000）
    }

    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let second = date.getSeconds();
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    hour = hour < 10 ? "0" + hour : hour;
    minute = minute < 10 ? "0" + minute : minute;
    second = second < 10 ? "0" + second : second;
    if (type === "date") {
      return `${year}${separator}${month}${separator}${day}`;
    } else if (type === "datetime") {
      return `${year}${separator}${month}${separator}${day} ${hour}:${minute}:${second}`;
    } else if (type === "time") {
      return `${hour}:${minute}:${second}`;
    } else return date;
  },
  // 16进制颜色转rgba
  getRGBA(hex, alpha = 1) {
    let rgb = [0, 0, 0];
    if (/#(..)(..)(..)/g.test(hex)) {
      rgb = [parseInt(RegExp.$1, 16), parseInt(RegExp.$2, 16), parseInt(RegExp.$3, 16)];
      rgb.push(alpha);
    }
    return `rgba(${rgb.join(',')})`;
  },
  // 转换为百分比
  transformPercentNumber(num, bit = 2) {
    const val = Number(num);
    if (Number.isNaN(val)) {
      return num;
    }
    return Number((val * 100).toFixed(bit));
  },
  toDecimal(num, bit = 2) {
    let result = parseFloat(num);
    if (Number.isNaN(result)) {
      return result;
    }
    const temp = Math.pow(10, bit);
    result = Math.floor(num * temp) / temp;
    return result;
  },
  // 验证邮箱
  verifyEmail(data) {
    // eslint-disable-next-line no-useless-escape
    const emailReg = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/;
    return emailReg.test(data);
  },
  // 验证手机号码
  verifyMobile(data) {
    const mobileReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
    return mobileReg.test(data);
  },
  // 验证用户名
  verifyUsername(data) {
    const usernameReg = /^[A-Za-z0-9]+$/;
    return usernameReg.test(data);
  },
  // 去除富文本中的空格
  removeContentSpace(content) {
    return content
      .replace(/<[^>]+>/gim, '')
      .replace(/&nbsp;/g, '')
      .replace(/\s*/g, '');
  },

  getObjectURL(file) {
    let url = null;
    if (window.createObjectURL !== undefined) {
      url = window.createObjectURL(file);
    } else if (window.URL !== undefined) { // mozilla(firefox)
      url = window.URL.createObjectURL(file);
    } else if (window.webkitURL !== undefined) { // webkit or chrome
      url = window.webkitURL.createObjectURL(file);
    }
    return url;
  },
  // 获取文件大小
  formatBytes(bytes, decimals) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals + 1 || 3;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  },

  // 将二进制转换成
  export(blob, name) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = (readerEvent) => {
        const a = document.createElement('a');
        a.download = name;
        console.log('readerEvent.target.result', readerEvent.target.result);
        a.href = readerEvent.target.result;
        a.style.display = 'none';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        resolve(true);
      };
    });
  },

  // 获取唯一ID
  getUniqueID(flag) {
    const id = `${new Date().getTime()}-${
      Math.random()
        .toString()
        .split('.')[1]
    }`;
    return flag ? `${flag}-${id}` : id;
  },

  // 格式化文件对象
  formatFileObj(file) {
    if (!file) {
      return;
    }
    const index = file.lastIndexOf('.');
    const suffix = file.substring(index, file.length);
    const name = file.substring(0, index);
    return {
      name,
      suffix,
    };
  },
};
